const fin_monthlypayment_reducer = (state = 0.00, action) => {
	switch(action.type) {

		case 'UPDATEDFINMONTHLYPAYMENTS':
			return typeof action.payload !== "undefined" ? action.payload : 0.00;

		default:
			return state;
	}
}

export default fin_monthlypayment_reducer;